import HeroSection from "../components/HeroSection";
import FeaturesStrip from "../components/FeaturesStrip";
import AboutSection from "../components/AboutSection";
import AdmissionShowcase from "../components/AdmissionShowcase";
import CoursesSection from "../components/CoursesSection";
import VideosSection from "../components/VideosSection";
import FacultySection from "../components/FacultySection";
import NewsHighlights from "../components/NewsHighlights";
import GoogleReviews from "../components/GoogleReviews";
import InstagramFeed from "../components/InstagramFeed";
import StatsSection from "../components/StatsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import PartnersSection from "../components/PartnersSection";
import AdmissionsCTA from "../components/AdmissionsCTA";

// Every section on the home page is registered here. `locked` means the
// section cannot be hidden or removed (Hero must always be present).
export const HOME_SECTIONS = {
  hero:         { label: "Hero Banner",          Component: HeroSection,       locked: true },
  about:        { label: "About Kiki",           Component: AboutSection },
  admission:    { label: "Admission Showcase",   Component: AdmissionShowcase },
  courses:      { label: "Trending Courses",     Component: CoursesSection },
  videos:       { label: "Video Highlights",     Component: VideosSection },
  faculty:      { label: "Our Faculty",          Component: FacultySection },
  news:         { label: "Latest News",          Component: NewsHighlights },
  reviews:      { label: "Google Reviews",       Component: GoogleReviews },
  instagram:    { label: "Instagram Feed",       Component: InstagramFeed },
  features:     { label: "Features Strip",       Component: FeaturesStrip },
  stats:        { label: "Stats Counters",       Component: StatsSection },
  testimonials: { label: "Student Testimonials", Component: TestimonialsSection },
  partners:     { label: "Partners Grid",        Component: PartnersSection },
  cta:          { label: "Admissions CTA Band",  Component: AdmissionsCTA },
};

// Default order used when no admin overrides have been saved yet.
// FeaturesStrip, Stats, Testimonials, Partners and CTA are OFF by default —
// they exist in the registry so admin can bring them back via the live editor.
export const DEFAULT_ORDER = [
  "hero",
  "about",
  "admission",
  "courses",
  "videos",
  "faculty",
  "news",
  "reviews",
  "instagram",
];

export const DEFAULT_CONFIG = { order: DEFAULT_ORDER, hidden: [] };

export function sectionKeys() {
  return Object.keys(HOME_SECTIONS);
}
